import type { IconMap } from 'autogen/iconMap';
import { useJavascriptRequestDataModelQuery } from 'autogen/swagger/all/hooks';
import type React from 'react';
import { forwardRef, type HTMLAttributes } from 'react';
import icons from './icons';
import { withErrorBoundary } from 'react-error-boundary';

export type IconProps = HTMLAttributes<HTMLOrSVGElement> &
    React.SVGAttributes<SVGElement> & { type: keyof IconMap; size: 16 | 24 };

// function getIcon({ tenant, type, size }: Pick<IconProps, 'type' | 'size'> & { tenant: string }) {
//     return dynamic(() => import(`../../../images/icons/design-system/${tenant}/${size}px/${type}.svg?react`), {
//         fallback: <div style={{ width: size, height: size }} />
//     });
// }

const Icon = forwardRef<SVGElement, IconProps>((props, ref) => {
    const { type, size, ...restProps } = props;
    const { data } = useJavascriptRequestDataModelQuery({ enabled: false });
    const tenant = data?.segmentation.tenant.toLowerCase() || 'matas';

    // const IconComponent = useMemo(() => getIcon({ tenant, type, size }), [type, size, tenant]);
    const iconElement = icons[`../../../images/icons/design-system/${tenant}/${size}px/${type}.svg`]?.default({
        ...restProps,
        ref
    });

    if (!iconElement) {
        return null;
    }

    return iconElement;
});

export default withErrorBoundary(Icon, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
